// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loaded with the app, not generated at runtime: the fitted size arrives as --auto-textfit-size.
   (As a styled-component it inserted its rule when the first crash-game card mounted - mid-scroll -
   and every rule inserted into that sheet made Chromium re-match the whole sheet against the page.) */
.z96VnlD5NxRKhBIoJL4Y {
  font-size: var(--auto-textfit-size);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/AutoTextfit/AutoTextfit.module.css"],"names":[],"mappings":"AAAA;;sGAEsG;AACtG;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* Loaded with the app, not generated at runtime: the fitted size arrives as --auto-textfit-size.\n   (As a styled-component it inserted its rule when the first crash-game card mounted - mid-scroll -\n   and every rule inserted into that sheet made Chromium re-match the whole sheet against the page.) */\n.text {\n  font-size: var(--auto-textfit-size);\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `z96VnlD5NxRKhBIoJL4Y`
};
export default ___CSS_LOADER_EXPORT___;
